import {
  PolicyContainer,
  PolicyTitle,
  PolicyText,
  PolicyList,
  PolicySectionTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";
import { useEffect } from "react";

const HealthEs = () => {
  useEffect(() => {
    document.documentElement.lang = "es";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <PolicyTitle>
        Consentimiento para la recopilación y el uso de datos de salud
      </PolicyTitle>

      <PolicyText>
        Al crear una cuenta, puedes elegir si deseas dar tu consentimiento para
        la recopilación y el uso de datos de salud. Este consentimiento es
        opcional y no es necesario para crear una cuenta de pregnancy&baby. Sin
        embargo, si no das tu consentimiento, es posible que no puedas utilizar
        las funciones que requieren el tratamiento de datos de salud.
      </PolicyText>

      <PolicySectionTitle>
        1. Finalidades de la recopilación y el uso
      </PolicySectionTitle>
      <PolicyHyphenList>
        <li>
          Proporcionar funciones de registro y gestión relacionadas con la
          preparación para el embarazo, los tratamientos de fertilidad, el
          embarazo y el cuidado infantil
        </li>
        <li>
          Proporcionar las funciones personalizadas que elijas, como la
          predicción de la menstruación y la ovulación, el cálculo de la edad
          gestacional, el análisis de los resultados de pruebas, el análisis del
          crecimiento fetal y el análisis del crecimiento y desarrollo infantil
        </li>
        <li>
          Proporcionar recordatorios e información relacionados con la salud, el
          embarazo y el cuidado infantil de acuerdo con tu configuración
        </li>
      </PolicyHyphenList>

      <PolicySectionTitle>2. Datos de salud que recopilamos</PolicySectionTitle>
      <PolicyList>
        <li>
          <strong>[Preparación para el embarazo]</strong>
          <br />
          Duración y ciclo menstrual, fecha de la última menstruación, fechas de
          inicio y fin de la menstruación, fecha de ovulación, fecha y hora,
          imágenes y resultados de las pruebas de ovulación, fecha y hora,
          imágenes y resultados de las pruebas de embarazo, temperatura basal,
          síntomas, registros de dolor y sangrado, actividad sexual, medicación,
          vacunación, consultas médicas y otra información relacionada con la
          salud que decidas registrar
        </li>
        <li>
          <strong>[Tratamientos de fertilidad]</strong>
          <br />
          Tipo de tratamiento de fertilidad, ciclo de tratamiento, fechas de
          inicio y finalización del tratamiento, registros de medicamentos e
          inyecciones, calendario del tratamiento y detalles del tratamiento
        </li>
        <li>
          <strong>[Embarazo]</strong>
          <br />
          Fecha estimada de parto, edad gestacional, registros de consultas
          médicas, vacunación, peso, imágenes de ecografía, mediciones fetales
          (EFW/AC/FL/BPD/HC/CRL), altura y peso antes del embarazo y otra
          información relacionada con el embarazo que decidas registrar
        </li>
        <li>
          <strong>[Cuidado infantil]</strong>
          <br />
          Fecha de nacimiento del niño, altura, peso y perímetro cefálico al
          nacer, mediciones de crecimiento, registros y puntuaciones de
          evaluaciones del desarrollo, fotografías relacionadas con el
          desarrollo, información sobre nacimiento prematuro, revisiones
          médicas, vacunación, temperatura corporal, medicación y registros de
          enfermedades
        </li>
      </PolicyList>

      <PolicySectionTitle>3. Período de conservación y uso</PolicySectionTitle>
      <PolicyText>
        Cuando elimines un registro guardado, también se eliminará la
        información asociada a dicho registro. Cuando elimines tu cuenta, se
        eliminarán los Datos Personales que permitan identificarte. No obstante,
        determinados datos generados durante el uso de los Servicios podrán
        conservarse indefinidamente con fines de investigación, análisis
        estadístico y mejora del servicio después de haber sido anonimizados de
        forma irreversible para que ya no sea posible identificarte. Los datos
        anonimizados no podrán volver a vincularse con tu cuenta ni con tus
        Datos Personales.
      </PolicyText>

      <PolicySectionTitle>
        Derecho a no prestar el consentimiento
      </PolicySectionTitle>
      <PolicyText>
        Este consentimiento es opcional. Puedes crear una cuenta de
        pregnancy&baby y utilizar las funciones que no requieran el tratamiento
        de datos de salud aunque no prestes este consentimiento. Sin embargo, si
        no das tu consentimiento, es posible que no puedas utilizar las
        funciones que requieran el tratamiento de datos de salud, incluidas las
        funciones de registro relacionadas con la preparación para el embarazo,
        los tratamientos de fertilidad, el embarazo y el cuidado infantil.
      </PolicyText>
    </PolicyContainer>
  );
};

export default HealthEs;
